import { render } from "./EnlargeableStreamPlayerLocal.vue?vue&type=template&id=36bb29e0&scoped=true"
import script from "./EnlargeableStreamPlayerLocal.vue?vue&type=script&lang=js"
export * from "./EnlargeableStreamPlayerLocal.vue?vue&type=script&lang=js"

import "./EnlargeableStreamPlayerLocal.vue?vue&type=style&index=0&id=36bb29e0&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bb29e0"]])

export default __exports__